import { NotFoundComponent } from './components/not-found/not-found.component';
import { ErrorComponent } from './components/error/error.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { SharedModule } from '../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutMainComponent } from './pages/layout-main/layout-main.component';
import { LayoutSidebarComponent } from './components/layout-sidebar/layout-sidebar.component';
import { LayoutTopbarComponent } from './components/layout-topbar/layout-topbar.component';
import { LoginComponent } from './components/login/login.component';
import { IbpaasBaseComponentModule } from '../base/ibpaas-base-component.module';



@NgModule({
  declarations: [
    LayoutMainComponent,
    LayoutSidebarComponent,
    LayoutTopbarComponent,
    AccessDeniedComponent,
    ErrorComponent,
    NotFoundComponent,
    LoginComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IbpaasBaseComponentModule
  ]
})
export class LayoutModule { }
